/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { logout } from '../../../../app/modules/auth/core/_requests'
// import {removeAuth, useAuth} from '../../../../app/modules/auth'
import { StoreModel } from '../../../../app/redux/types'
import {toAbsoluteUrl} from '../../../helpers'

const HeaderUserMenu: FC = () => {
  // const {logout} = useAuth()
  const {currentUser} = useSelector((state: StoreModel) => state.globalStates)
  const dispatch = useDispatch()
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('/media/avatars/blank.png')} />
          </div>

          <div className='d-flex flex-column hover-pointer'>
            <div className='fw-bold d-flex align-items-center fs-5'>
              {currentUser?.role_name}
            </div>
            <div className='fw-bold text-muted text-hover-primary fs-7 text-break'>
              {currentUser?.email}
            </div>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>


      <div className='px-5 fs-6 hover-pointer'>
        <div className='mb-1'>
          <label className='text-muted'>Logged In As:{"\u00a0\u00a0"}</label>
            <span className='fw-normal text-gray-400 text-hover-primary'> {currentUser?.current_business_name}</span>

        </div>
        <div className='mb-1'>
          <label className='text-muted'>Role:{"\u00a0\u00a0"}</label>
            <span className='fw-normal text-gray-400 text-hover-primary'>{currentUser?.role_name}</span>

        </div>
        <div className='mb-1'>
          <label className='fw-bold text-muted'>Department:{"\u00a0\u00a0"}</label>
            <span className='fw-normal text-gray-400 text-hover-primary'>{currentUser?.department_name}</span>
        </div>

        <div className='mb-1'>
          <label className='fw-bold text-muted'>Profile:{"\u00a0\u00a0"}</label>
            <span className='fw-normal text-gray-400 text-hover-primary'>{currentUser?.profile_name}</span>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <a onClick={()=>{logout(dispatch)}} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
